import axios from "axios";
import {GET_CURRENTUSER, SET_CURRENTUSER_LOADING, GET_CURRENTUSER_FAIL, CLEAR_CURRENTUSER} from '../actions/types'
const token =  localStorage.getItem("token");
const headers =  {
  'Accept': "application/json",
  "Content-Type": "application/json",
  "Authorization":`JWT ${token}`

}
//get
export const getCurrentUser =(params)=>async dispatch => {
    dispatch({type: CLEAR_CURRENTUSER})
    dispatch({ type: SET_CURRENTUSER_LOADING })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/users/current_user/`,
        params: params,
      };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
      try {
        const response = await axios(config);
        dispatch({
          type: GET_CURRENTUSER,
          payload: response.data
        });
    
      }catch (err) {
        console.log("error: ", JSON.stringify(err))
       
        dispatch({
          type: GET_CURRENTUSER_FAIL,
        });
      }
  }